import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const societyApi = {
  getSocieties: (params) => api.get(API_ROUTES.superadmin.societies, { params }),
  getSocietyById: (id) => api.get(API_ROUTES.superadmin.society(id)),
  createSociety: (data) => api.post(API_ROUTES.superadmin.societies, data),
  updateSociety: (id, data) => api.put(API_ROUTES.superadmin.society(id), data),
  deleteSociety: (id) => api.delete(API_ROUTES.superadmin.society(id)),
  getDashboard: () => api.get(API_ROUTES.superadmin.dashboard),
  createAdminUser: (data) => api.post(API_ROUTES.superadmin.adminUsers, data),
  getAdminUsers: (params) => api.get(API_ROUTES.superadmin.adminUsers, { params }),
  createSocietyAdmin: (data) => api.post(API_ROUTES.superadmin.societyAdmins, data),
  getSocietyAdmins: (params) => api.get(API_ROUTES.superadmin.societyAdmins, { params }),
  updateAdminUserStatus: (id, data) => api.patch(API_ROUTES.superadmin.adminUserStatus(id), data),
  updateAdminUserAccess: (id, data) => api.patch(API_ROUTES.superadmin.adminUserAccess(id), data),
  resendAdminUserInvite: (id) => api.post(API_ROUTES.superadmin.adminUserResendInvite(id)),
  getSocietyAdminDashboard: () => api.get(API_ROUTES.societyAdmin.dashboard),
  createManager: (data) => api.post(API_ROUTES.societyAdmin.managers, data),
  getManagers: (params) => api.get(API_ROUTES.societyAdmin.managers, { params }),
  updateManagerStatus: (id, data) => api.patch(API_ROUTES.societyAdmin.managerStatus(id), data),
  updateManagerAccess: (id, data) => api.patch(API_ROUTES.societyAdmin.managerAccess(id), data),
  resendManagerInvite: (id) => api.post(API_ROUTES.societyAdmin.managerResendInvite(id)),
  getSocietyRoles: () => api.get(API_ROUTES.societyAdmin.roles),
  getSocietyRolePermissions: () => api.get(API_ROUTES.societyAdmin.roleAvailablePermissions),
  createSocietyRole: (data) => api.post(API_ROUTES.societyAdmin.roles, data),
  updateSocietyRole: (id, data) => api.put(API_ROUTES.societyAdmin.role(id), data),
  deleteSocietyRole: (id) => api.delete(API_ROUTES.societyAdmin.role(id)),
};
